<template>
    <div class="fw-itinfo">
        <van-nav-bar :title="title" style="background-color: #CCD5E6;" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <p v-html="imgText.description" v-if="imgText.itType==2"></p>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                title:'详情',
                id:'',
                imgText:{},
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.id=this.$route.query.id
            this.getSysImgText()
        },
        methods: {
            async getSysImgText() {
                let res = await this.$get("/fw/getSysImgText", {id:this.id})
                this.imgText=res.imgText
            },
            onClickLeft(){
                this.$router.go(-1)
            },
        },
    };
</script>

<style lang="scss" scoped>

    .fw-itinfo {
        margin: 0 auto;
        height: 100%;
        padding-top: 46px;
        background-color: #ffffff;
        position: relative;
    }

</style>
